// TODO: ve skutečnosti se používá custom control, ale není to moc dořešené, nepoužívá totiž klasický ContainerEditableControl, pomocí kterého by s ním mohlo komunikovat okolí,
// TODO: např. mu kvůli tomu nejdou nastavit práva (viditelnost, editovatelnost...), ideální by to bylo dodělat jako to má NumEdit
import { IAttrValue } from "@multiweb/types/contracts";
import { IValidatable } from "../../../../UI.BaseControls/ControlInterfaces";
import { ValidatableControl } from "../../../../UI.BaseControls/ValidatableControl";
import { FileEditElement } from "../../../FileEditElement";
import { Column } from "../../Columns/Column";
import { EditItemTemplate } from "../EditItemTemplate";

export class FileEditTemplate extends EditItemTemplate {
    protected override _createEditElement(_column: Column, dataSet: IAttrValue[], _parentItem: HTMLElement): { element: HTMLElement; validatableControl: IValidatable } {
        const fe = new FileEditElement();
        const data = this._getDataFromSet(dataSet);
        fe.value = data ? data.toString() : "";

        return { element: fe as HTMLElement, validatableControl: new ValidatableControl(fe as HTMLElement) };
    }

    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        (item as FileEditElement).value = await this.parentColumn.formatValue(this._getDataFromSet(dataSet));
    }
}
